import { Controller } from "@hotwired/stimulus"

// Auto-fills each quote line's unit price from the selected product/variant's
// price for the chosen tier (End user / Dealer / Bulk); the field stays
// editable afterwards, same as the POS sale-type switch.
export default class extends Controller {
  static targets = ["tier", "row", "productSelect", "variantSelect", "unitPrice"]
  static values = { prices: Object }

  changeTier() {
    this.rowTargets.forEach((row) => this.applyPrice(row))
  }

  changeProduct(event) {
    this.applyPrice(event.target.closest("[data-quote-pricing-target='row']"))
  }

  applyPrice(row) {
    if (!row) return

    const variantSelect = row.querySelector("[data-quote-pricing-target='variantSelect']")
    const productSelect = row.querySelector("[data-quote-pricing-target='productSelect']")
    const unitPriceInput = row.querySelector("[data-quote-pricing-target='unitPrice']")

    const key = variantSelect?.value ? `variant-${variantSelect.value}` :
                productSelect?.value ? `product-${productSelect.value}` : null
    const prices = key && this.pricesValue[key]
    if (!prices) return

    const tier = this.tierTarget.value
    unitPriceInput.value = parseFloat(prices[tier] ?? prices.retail ?? 0).toFixed(2)
  }
}
